import React from "react";

import {AiOutlineTable, AiOutlineDashboard} from "react-icons/ai";
import {HiOutlineDocumentReport} from "react-icons/hi";
import {IoMdInformationCircleOutline} from "react-icons/io";

import {BsPeople} from "react-icons/bs";
import {PERMISSION} from "../../configs/global";
export const SidebarData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <AiOutlineDashboard className="nav-icon" />,
    cName: "nav-item",
    permissions: [
      PERMISSION.SUPER,
      PERMISSION.ADMIN,
      PERMISSION.MANAGER,
      PERMISSION.VIEWER,
    ],
  },
  {
    title: "Main",
    path: "/main",
    icon: <IoMdInformationCircleOutline className="nav-icon" />,

    permissions: [
      PERMISSION.SUPER,
      PERMISSION.ADMIN,
      PERMISSION.MANAGER,
      PERMISSION.VIEWER,
    ],
  },
  {
    title: "Configuration",
    path: "/config",
    icon: <AiOutlineTable className="nav-icon" />,

    permissions: [PERMISSION.SUPER, PERMISSION.ADMIN, PERMISSION.MANAGER],
  },
  {
    title: "Reports",
    path: "/report",
    icon: <HiOutlineDocumentReport className="nav-icon" />,

    permissions: [
      PERMISSION.SUPER,
      PERMISSION.ADMIN,
      PERMISSION.MANAGER,
      PERMISSION.VIEWER,
    ],
  },
  {
    title: "Manage Account",
    path: "/manage-accounts",
    icon: <BsPeople className="nav-icon" />,

    permissions: [PERMISSION.SUPER, PERMISSION.ADMIN],
  },
];
